// Module
var code = "<react-component name=\"BulkDeleteMakeupClasses\"></react-component>\n";
// Exports
module.exports = code;